import React from 'react';
import autobind from "autobind-decorator";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Component } from 'core/components';
import { Link, Card, CardHeader } from 'core/components/Framework7';

import classes from './styles.module.css';

class CategoryItem extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { item, env } = this.props
    return (
      <Link raised href={`/node/${item.link}`} className={classes.container}>
        <Card className={classes.fitRatio}>
          <CardHeader
            className={`no-border ${classes.cardHeader}`}
            valign="bottom"
            style={{ backgroundImage: `url(${item.url})` }}
          >
            {env && env.categoryTitle === 'visible' &&
              <p className={classes.titleInCard}>{item.title}</p>
            }
          </CardHeader>
        </Card>
      </Link>
    )
  }
}

export default connect(
  state => ({
    env: state.General.env,
  }),
  {}
)(autobind(CategoryItem));